<!-- TelegramLogin.vue -->
<template>
  <div ref="telegramLoginBtn"></div>
</template>

<script>
import DipSip from "@/views/DipSip.vue";

export default {
  name: "TelegramLogin",
  props: {
    botName: {
      type: String,
      required: true,
    },
  },
  mounted() {
    const tg_bot_name = "DipSipLogin_bot"; // Default bot name
    console.log("TG Bot Name:", tg_bot_name);

    const script = document.createElement("script");
    script.src = "https://telegram.org/js/telegram-widget.js?22";
    script.async = true;
    console.log("TG", import.meta.env);
    console.log("data-telegram-login", this.botName);
    script.setAttribute("data-telegram-login", tg_bot_name);
    script.setAttribute("data-size", "large");
    script.setAttribute("data-onauth", "onTelegramAuth(user)");
    script.setAttribute("data-request-access", "write");

    this.$refs.telegramLoginBtn.appendChild(script);

    window.onTelegramAuth = (user) => {
      this.$emit("telegram-auth", user);
    };
  },
};
</script>
